const rxEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const rxNumber = /^[0-9]*$/
const rxDecimal = /^[1-9]\d*(\.\d+)?$/
const rxCurrency = /^[1-9]\d*(\.\d+)?$/
const rxUppercase = /^(.*[A-Z].*)$/

export { rxCurrency, rxDecimal, rxEmail, rxNumber, rxUppercase }
